import { actions } from './actions'

const projectToManage = (state = {}, action) => {
  switch (action.type) {
    case actions.set:
      return action.projectToManage
    default:
      return state
  }
}

export default projectToManage
